const TABLE_CONSTANTS = {
    OFFSET_STARTING_VALUE: 0,
    ROWS_NUMBER_PER_PAGE: 100
};

export default TABLE_CONSTANTS;